import { ITypedReduxAction } from '../../types/redux/actionType';
import { actionGenerator } from '../../utils/redux/actionGenerator';
import { EUserStatus } from '../../types/newAnswer/userStatus';

export enum EUserStatusActionTypes {
  SetUserStatus = 'NEW_ANSWER/USER_STATUS/SET',
}

export type TSetUserStatusAnswerType = ITypedReduxAction<EUserStatusActionTypes.SetUserStatus, EUserStatus>;

/**
 * Redux action, который записывает в store информацию о статусе пользователя нового ответа
 * @param userStatus EUserStatus
 */
export const setUserStatus: (userStatus: EUserStatus) => TSetUserStatusAnswerType = actionGenerator<
  EUserStatusActionTypes.SetUserStatus,
  EUserStatus
>(EUserStatusActionTypes.SetUserStatus);

export type TSetUserStatusAnswer = TSetUserStatusAnswerType;
